// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/artifacts/v1/dashboard.proto (package chalk.artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { MetricConfigSeries, MetricFormula, ThresholdKind } from "./chart_pb";
import { file_chalk_artifacts_v1_chart } from "./chart_pb";
import type { ContentRole, ContentVisibility } from "./contentgrant_pb";
import { file_chalk_artifacts_v1_contentgrant } from "./contentgrant_pb";
import type { ValueTone } from "./value_tone_pb";
import { file_chalk_artifacts_v1_value_tone } from "./value_tone_pb";
import type { AggregateOptions, RateOptions } from "../../searchaggregates/v1/aggregation_pb";
import { file_chalk_searchaggregates_v1_aggregation } from "../../searchaggregates/v1/aggregation_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/artifacts/v1/dashboard.proto.
 */
export const file_chalk_artifacts_v1_dashboard: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_artifacts_v1_chart, file_chalk_artifacts_v1_contentgrant, file_chalk_artifacts_v1_value_tone, file_chalk_searchaggregates_v1_aggregation, file_google_api_field_behavior, file_google_protobuf_timestamp]);

/**
 * Placement of a single widget on the dashboard's 12-column grid, in grid cells: x/y are the
 * top-left position (columns/rows) and w/h are the size (column/row span).
 *
 * @generated from message chalk.artifacts.v1.GridPosition
 */
export type GridPosition = Message<"chalk.artifacts.v1.GridPosition"> & {
  /**
   * @generated from field: int32 x = 1;
   */
  x: number;

  /**
   * @generated from field: int32 y = 2;
   */
  y: number;

  /**
   * @generated from field: int32 w = 3;
   */
  w: number;

  /**
   * @generated from field: int32 h = 4;
   */
  h: number;
};

/**
 * Describes the message chalk.artifacts.v1.GridPosition.
 * Use `create(GridPositionSchema)` to create a new message.
 */
export const GridPositionSchema: GenMessage<GridPosition> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 0);

/**
 * A single widget placed on a dashboard: where it sits (`position`) plus what it is (`definition`).
 *
 * @generated from message chalk.artifacts.v1.DashboardWidget
 */
export type DashboardWidget = Message<"chalk.artifacts.v1.DashboardWidget"> & {
  /**
   * Stable, client-generated id, unique within a dashboard.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: chalk.artifacts.v1.GridPosition position = 2;
   */
  position?: GridPosition;

  /**
   * @generated from oneof chalk.artifacts.v1.DashboardWidget.definition
   */
  definition: {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardDataWidget data_widget = 3;
     */
    value: DashboardDataWidget;
    case: "dataWidget";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardMarkdownWidget markdown = 4;
     */
    value: DashboardMarkdownWidget;
    case: "markdown";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardSectionTitleWidget section_title = 5;
     */
    value: DashboardSectionTitleWidget;
    case: "sectionTitle";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardNotebookCellWidget notebook_cell = 6;
     */
    value: DashboardNotebookCellWidget;
    case: "notebookCell";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardMonitorWidget monitor_widget = 7;
     */
    value: DashboardMonitorWidget;
    case: "monitorWidget";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardLatestDeploymentWidget latest_deployment = 8;
     */
    value: DashboardLatestDeploymentWidget;
    case: "latestDeployment";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardIncidentWidget incident_widget = 9;
     */
    value: DashboardIncidentWidget;
    case: "incidentWidget";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardConnectionHealthWidget connection_health = 10;
     */
    value: DashboardConnectionHealthWidget;
    case: "connectionHealth";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.artifacts.v1.DashboardWidget.
 * Use `create(DashboardWidgetSchema)` to create a new message.
 */
export const DashboardWidgetSchema: GenMessage<DashboardWidget> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 1);

/**
 * Per-placement rendering options for a notebook cell widget. The zero message means "show the
 * cell's output with default presentation"; every future field's default must preserve that so
 * existing widgets never change appearance when fields are added. Future options (output
 * selection, title override, table/chart fit, run pinning) are added as siblings of `mode`,
 * not as enum values.
 *
 * @generated from message chalk.artifacts.v1.NotebookCellDisplay
 */
export type NotebookCellDisplay = Message<"chalk.artifacts.v1.NotebookCellDisplay"> & {
  /**
   * @generated from field: chalk.artifacts.v1.NotebookCellDisplayMode mode = 1;
   */
  mode: NotebookCellDisplayMode;
};

/**
 * Describes the message chalk.artifacts.v1.NotebookCellDisplay.
 * Use `create(NotebookCellDisplaySchema)` to create a new message.
 */
export const NotebookCellDisplaySchema: GenMessage<NotebookCellDisplay> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 2);

/**
 * A widget that renders a notebook cell. Soft string refs; the service owning the referenced
 * notebook validates them. In a standalone dashboard the widget renders the cell's latest
 * persisted run output (no kernel, no live inputs). Inside a notebook app's backing dashboard,
 * notebook_id must equal the owning notebook and the host supplies live run results.
 *
 * @generated from message chalk.artifacts.v1.DashboardNotebookCellWidget
 */
export type DashboardNotebookCellWidget = Message<"chalk.artifacts.v1.DashboardNotebookCellWidget"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string cell_id = 2;
   */
  cellId: string;

  /**
   * @generated from field: chalk.artifacts.v1.NotebookCellDisplay display = 3;
   */
  display?: NotebookCellDisplay;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardNotebookCellWidget.
 * Use `create(DashboardNotebookCellWidgetSchema)` to create a new message.
 */
export const DashboardNotebookCellWidgetSchema: GenMessage<DashboardNotebookCellWidget> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 3);

/**
 * A query-backed dashboard widget: the data it pulls (`query`) and how it renders (`visualization`),
 * chosen independently. Not every combination is drawable, so the server enforces the
 * compatibility matrix on write: metric_query -> timeseries; source_query(logs) -> timeseries | table.
 *
 * @generated from message chalk.artifacts.v1.DashboardDataWidget
 */
export type DashboardDataWidget = Message<"chalk.artifacts.v1.DashboardDataWidget"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * metric_query is planned to deprecate into source_query once a string metrics query
   * language exists; new string-queryable sources are just new data_source values.
   *
   * @generated from oneof chalk.artifacts.v1.DashboardDataWidget.data_query
   */
  dataQuery: {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardMetricQuery metric_query = 2;
     */
    value: DashboardMetricQuery;
    case: "metricQuery";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardSourceQuery source_query = 3;
     */
    value: DashboardSourceQuery;
    case: "sourceQuery";
  } | { case: undefined; value?: undefined };

  /**
   * New renderings (e.g. a statistic tile) are added as variants here.
   *
   * @generated from oneof chalk.artifacts.v1.DashboardDataWidget.visualization
   */
  visualization: {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardTimeseriesViz timeseries = 4;
     */
    value: DashboardTimeseriesViz;
    case: "timeseries";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardTableViz table = 5;
     */
    value: DashboardTableViz;
    case: "table";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardStatisticViz statistic = 6;
     */
    value: DashboardStatisticViz;
    case: "statistic";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardTreeMapViz tree_map = 7;
     */
    value: DashboardTreeMapViz;
    case: "treeMap";
  } | {
    /**
     * @generated from field: chalk.artifacts.v1.DashboardPieViz pie = 8;
     */
    value: DashboardPieViz;
    case: "pie";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.artifacts.v1.DashboardDataWidget.
 * Use `create(DashboardDataWidgetSchema)` to create a new message.
 */
export const DashboardDataWidgetSchema: GenMessage<DashboardDataWidget> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 4);

/**
 * @generated from message chalk.artifacts.v1.DashboardMonitorWidget
 */
export type DashboardMonitorWidget = Message<"chalk.artifacts.v1.DashboardMonitorWidget"> & {
  /**
   * @generated from field: string monitor_id = 1;
   */
  monitorId: string;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardMonitorWidget.
 * Use `create(DashboardMonitorWidgetSchema)` to create a new message.
 */
export const DashboardMonitorWidgetSchema: GenMessage<DashboardMonitorWidget> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 5);

/**
 * Renders the selected Connections-page health summaries for the dashboard's environment. At least one
 * connection id is required. IDs are owned by the Connections UI, so new health-check groups do not
 * require changes to this portable dashboard schema.
 *
 * @generated from message chalk.artifacts.v1.DashboardConnectionHealthWidget
 */
export type DashboardConnectionHealthWidget = Message<"chalk.artifacts.v1.DashboardConnectionHealthWidget"> & {
  /**
   * @generated from field: repeated string connection_ids = 1;
   */
  connectionIds: string[];
};

/**
 * Describes the message chalk.artifacts.v1.DashboardConnectionHealthWidget.
 * Use `create(DashboardConnectionHealthWidgetSchema)` to create a new message.
 */
export const DashboardConnectionHealthWidgetSchema: GenMessage<DashboardConnectionHealthWidget> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 6);

/**
 * Renders the most recent deployment in the dashboard's environment. It has no configuration:
 * the deployment and active-deployment status are resolved when the widget renders.
 *
 * @generated from message chalk.artifacts.v1.DashboardLatestDeploymentWidget
 */
export type DashboardLatestDeploymentWidget = Message<"chalk.artifacts.v1.DashboardLatestDeploymentWidget"> & {
};

/**
 * Describes the message chalk.artifacts.v1.DashboardLatestDeploymentWidget.
 * Use `create(DashboardLatestDeploymentWidgetSchema)` to create a new message.
 */
export const DashboardLatestDeploymentWidgetSchema: GenMessage<DashboardLatestDeploymentWidget> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 7);

/**
 * A list of recent incidents, optionally narrowed by the same filters as ListIncidents.
 * An unset filters message means all recent incidents.
 *
 * @generated from message chalk.artifacts.v1.DashboardIncidentWidget
 */
export type DashboardIncidentWidget = Message<"chalk.artifacts.v1.DashboardIncidentWidget"> & {
  /**
   * @generated from field: chalk.artifacts.v1.DashboardIncidentFilters filters = 1;
   */
  filters?: DashboardIncidentFilters;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardIncidentWidget.
 * Use `create(DashboardIncidentWidgetSchema)` to create a new message.
 */
export const DashboardIncidentWidgetSchema: GenMessage<DashboardIncidentWidget> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 8);

/**
 * Incident filters supported by the dashboard widget. They stay independent of
 * chalk.server.v1.ListIncidentsFilters because the monitoring service imports artifacts.v1.
 *
 * @generated from message chalk.artifacts.v1.DashboardIncidentFilters
 */
export type DashboardIncidentFilters = Message<"chalk.artifacts.v1.DashboardIncidentFilters"> & {
  /**
   * @generated from field: optional bool has_closed_filter = 2;
   */
  hasClosedFilter?: boolean;

  /**
   * Legacy numeric incidents API enum. New widgets use linked_entity_kind instead.
   *
   * @generated from field: optional int32 linked_entity_kind_filter = 3 [deprecated = true];
   * @deprecated
   */
  linkedEntityKindFilter?: number;

  /**
   * @generated from field: optional string linked_entity_id_filter = 4;
   */
  linkedEntityIdFilter?: string;

  /**
   * Stable entity-kind ID (for example, "feature" or "resolver"). The dashboard artifact keeps
   * this human-readable rather than coupling to the incidents API enum's number.
   *
   * @generated from field: optional string linked_entity_kind = 5;
   */
  linkedEntityKind?: string;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardIncidentFilters.
 * Use `create(DashboardIncidentFiltersSchema)` to create a new message.
 */
export const DashboardIncidentFiltersSchema: GenMessage<DashboardIncidentFilters> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 9);

/**
 * A structured metrics query, reusing the MetricConfigSeries/MetricFormula types charts and
 * monitors use today. MetricConfig's alerting/identity envelope (trigger, id, graph_generated) is
 * deliberately omitted — a data widget never alerts (that is a Monitor) and is never code-generated.
 * The server projects these fields into a MetricConfig for the existing GetChartSnapshot path.
 *
 * @generated from message chalk.artifacts.v1.DashboardMetricQuery
 */
export type DashboardMetricQuery = Message<"chalk.artifacts.v1.DashboardMetricQuery"> & {
  /**
   * Evaluation bucket, e.g. "5m".
   *
   * @generated from field: string window_period = 1;
   */
  windowPeriod: string;

  /**
   * @generated from field: repeated chalk.artifacts.v1.MetricConfigSeries series = 2;
   */
  series: MetricConfigSeries[];

  /**
   * @generated from field: repeated chalk.artifacts.v1.MetricFormula formulas = 3;
   */
  formulas: MetricFormula[];

  /**
   * Display re-bucketing override; empty => frontend default. Time-series only; a statistic tile
   * evaluates the whole range as one bucket and ignores it.
   *
   * @generated from field: optional string display_window_period = 4;
   */
  displayWindowPeriod?: string;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardMetricQuery.
 * Use `create(DashboardMetricQuerySchema)` to create a new message.
 */
export const DashboardMetricQuerySchema: GenMessage<DashboardMetricQuery> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 10);

/**
 * A query against any source whose query language is a string. The server validates data_source
 * against a closed set on write, and re-parses `query` so an unparseable query is never persisted.
 *
 * @generated from message chalk.artifacts.v1.DashboardSourceQuery
 */
export type DashboardSourceQuery = Message<"chalk.artifacts.v1.DashboardSourceQuery"> & {
  /**
   * Which backend evaluates `query`
   *
   * @generated from field: string data_source = 1;
   */
  dataSource: string;

  /**
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * Unset means the raw list. Mutually exclusive with the legacy inline `COUNT BY` clause in `query`.
   *
   * @generated from field: optional chalk.searchaggregates.v1.AggregateOptions aggregate_options = 3;
   */
  aggregateOptions?: AggregateOptions;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardSourceQuery.
 * Use `create(DashboardSourceQuerySchema)` to create a new message.
 */
export const DashboardSourceQuerySchema: GenMessage<DashboardSourceQuery> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 11);

/**
 * Renders a time-series frame as a chart.
 *
 * @generated from message chalk.artifacts.v1.DashboardTimeseriesViz
 */
export type DashboardTimeseriesViz = Message<"chalk.artifacts.v1.DashboardTimeseriesViz"> & {
  /**
   * frontend MetricChartPlotStyle union; empty => "line"
   *
   * @generated from field: string plot_style = 1;
   */
  plotStyle: string;

  /**
   * Series labels hidden when the chart first mounts. Viewer legend interactions remain local and
   * do not rewrite this shared authoring default.
   *
   * @generated from field: repeated string initially_hidden_series = 2;
   */
  initiallyHiddenSeries: string[];

  /**
   * Optional display label for the y axis. This does not change the underlying series units.
   *
   * @generated from field: optional string y_axis_label = 3;
   */
  yAxisLabel?: string;

  /**
   * Hide zero and null values from the hover tooltip.
   *
   * @generated from field: bool hide_falsy_in_tooltip = 4;
   */
  hideFalsyInTooltip: boolean;

  /**
   * Preferred y-axis bounds that expand to include data outside them.
   *
   * @generated from field: optional double y_axis_soft_min = 5;
   */
  yAxisSoftMin?: number;

  /**
   * @generated from field: optional double y_axis_soft_max = 6;
   */
  yAxisSoftMax?: number;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardTimeseriesViz.
 * Use `create(DashboardTimeseriesVizSchema)` to create a new message.
 */
export const DashboardTimeseriesVizSchema: GenMessage<DashboardTimeseriesViz> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 12);

/**
 * One column's presentation in a table widget; an unset field defers to the renderer's default.
 *
 * @generated from message chalk.artifacts.v1.DashboardTableColumn
 */
export type DashboardTableColumn = Message<"chalk.artifacts.v1.DashboardTableColumn"> & {
  /**
   * Client-minted identity, unique in the table but not globally. Never a label or index:
   * "timestamp", "attribute:pod", "p95:duration".
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * Authored width in CSS pixels; renderers clamp it to their container.
   *
   * @generated from field: optional int32 width_px = 2;
   */
  widthPx?: number;

  /**
   * True also adds a column outside the renderer's default set, e.g. a log attribute.
   *
   * @generated from field: optional bool visible = 3;
   */
  visible?: boolean;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardTableColumn.
 * Use `create(DashboardTableColumnSchema)` to create a new message.
 */
export const DashboardTableColumnSchema: GenMessage<DashboardTableColumn> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 13);

/**
 * Renders result rows as a table.
 *
 * @generated from message chalk.artifacts.v1.DashboardTableViz
 */
export type DashboardTableViz = Message<"chalk.artifacts.v1.DashboardTableViz"> & {
  /**
   * Sparse overrides with unique keys; order here is not significant.
   *
   * @generated from field: repeated chalk.artifacts.v1.DashboardTableColumn columns = 1;
   */
  columns: DashboardTableColumn[];

  /**
   * Full order once the user reorders; unlisted columns follow in the renderer's default order.
   *
   * @generated from field: repeated string column_order = 2;
   */
  columnOrder: string[];
};

/**
 * Describes the message chalk.artifacts.v1.DashboardTableViz.
 * Use `create(DashboardTableVizSchema)` to create a new message.
 */
export const DashboardTableVizSchema: GenMessage<DashboardTableViz> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 14);

/**
 * Each group's share of the ranked measure as a region's area; the shares come from aggregate_options.
 *
 * @generated from message chalk.artifacts.v1.DashboardTreeMapViz
 */
export type DashboardTreeMapViz = Message<"chalk.artifacts.v1.DashboardTreeMapViz"> & {
};

/**
 * Describes the message chalk.artifacts.v1.DashboardTreeMapViz.
 * Use `create(DashboardTreeMapVizSchema)` to create a new message.
 */
export const DashboardTreeMapVizSchema: GenMessage<DashboardTreeMapViz> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 15);

/**
 * The same shares as a donut, where a wedge's angle is its share.
 *
 * @generated from message chalk.artifacts.v1.DashboardPieViz
 */
export type DashboardPieViz = Message<"chalk.artifacts.v1.DashboardPieViz"> & {
  /**
   * Drop the legend beside the ring, which gives the ring the width instead; default shows it.
   *
   * @generated from field: bool hide_legend = 1;
   */
  hideLegend: boolean;

  /**
   * Drop the leader labels too, giving the ring the room they reserve; default shows them.
   *
   * @generated from field: bool hide_labels = 2;
   */
  hideLabels: boolean;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardPieViz.
 * Use `create(DashboardPieVizSchema)` to create a new message.
 */
export const DashboardPieVizSchema: GenMessage<DashboardPieViz> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 16);

/**
 * A single-scalar "statistic" tile, optionally with a percentage-change subtitle. Presentation only:
 * the scalar comes from the backing metrics/logs service, which evaluates the whole range as one
 * bucket and aggregates by the series' window_function.
 *
 * @generated from message chalk.artifacts.v1.DashboardStatisticViz
 */
export type DashboardStatisticViz = Message<"chalk.artifacts.v1.DashboardStatisticViz"> & {
  /**
   * Also evaluate the preceding equal-length window and show the percentage change.
   *
   * @generated from field: bool compare_to_previous = 1;
   */
  compareToPrevious: boolean;

  /**
   * Frontend numeral format (e.g. "0,0", "0.0%"); empty => default.
   *
   * @generated from field: optional string number_format = 2;
   */
  numberFormat?: string;

  /**
   * Override for the unit the backend returns on the stat result; unset => use the returned unit.
   *
   * @generated from field: optional string unit_label = 3;
   */
  unitLabel?: string;

  /**
   * When set, the tile shows a per-interval rate instead of the window total.
   *
   * @generated from field: optional chalk.searchaggregates.v1.RateOptions rate_options = 4;
   */
  rateOptions?: RateOptions;

  /**
   * @generated from field: optional chalk.artifacts.v1.ValueColoring coloring = 5;
   */
  coloring?: ValueColoring;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardStatisticViz.
 * Use `create(DashboardStatisticVizSchema)` to create a new message.
 */
export const DashboardStatisticVizSchema: GenMessage<DashboardStatisticViz> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 17);

/**
 * One threshold band: when `comparison` holds between the tile's value and `value`, it wears `tone`.
 *
 * @generated from message chalk.artifacts.v1.ValueColorRule
 */
export type ValueColorRule = Message<"chalk.artifacts.v1.ValueColorRule"> & {
  /**
   * @generated from field: chalk.artifacts.v1.ThresholdKind comparison = 1;
   */
  comparison: ThresholdKind;

  /**
   * @generated from field: double value = 2;
   */
  value: number;

  /**
   * @generated from field: chalk.artifacts.v1.ValueTone tone = 3;
   */
  tone: ValueTone;
};

/**
 * Describes the message chalk.artifacts.v1.ValueColorRule.
 * Use `create(ValueColorRuleSchema)` to create a new message.
 */
export const ValueColorRuleSchema: GenMessage<ValueColorRule> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 18);

/**
 * Threshold-driven coloring. Unset and "set with no rules" are both the renderer's default styling.
 *
 * @generated from message chalk.artifacts.v1.ValueColoring
 */
export type ValueColoring = Message<"chalk.artifacts.v1.ValueColoring"> & {
  /**
   * Evaluated in order against the *displayed* value, first match wins; an unsorted set still resolves.
   *
   * @generated from field: repeated chalk.artifacts.v1.ValueColorRule rules = 1;
   */
  rules: ValueColorRule[];

  /**
   * Worn when no rule matches; unspecified => neutral.
   *
   * @generated from field: chalk.artifacts.v1.ValueTone default_tone = 2;
   */
  defaultTone: ValueTone;
};

/**
 * Describes the message chalk.artifacts.v1.ValueColoring.
 * Use `create(ValueColoringSchema)` to create a new message.
 */
export const ValueColoringSchema: GenMessage<ValueColoring> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 19);

/**
 * A free-form text widget rendered as GitHub-flavored markdown.
 *
 * @generated from message chalk.artifacts.v1.DashboardMarkdownWidget
 */
export type DashboardMarkdownWidget = Message<"chalk.artifacts.v1.DashboardMarkdownWidget"> & {
  /**
   * @generated from field: string content = 1;
   */
  content: string;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardMarkdownWidget.
 * Use `create(DashboardMarkdownWidgetSchema)` to create a new message.
 */
export const DashboardMarkdownWidgetSchema: GenMessage<DashboardMarkdownWidget> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 20);

/**
 * A section divider row: an optional title and a rule that visually groups the widgets below it.
 *
 * @generated from message chalk.artifacts.v1.DashboardSectionTitleWidget
 */
export type DashboardSectionTitleWidget = Message<"chalk.artifacts.v1.DashboardSectionTitleWidget"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;
};

/**
 * Describes the message chalk.artifacts.v1.DashboardSectionTitleWidget.
 * Use `create(DashboardSectionTitleWidgetSchema)` to create a new message.
 */
export const DashboardSectionTitleWidgetSchema: GenMessage<DashboardSectionTitleWidget> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 21);

/**
 * A dashboard artifact: environment-scoped name + widgets. Lives in artifacts/v1 so the SDK can
 * emit it and `chalk apply` can reconcile it when code-defined dashboards land.
 *
 * @generated from message chalk.artifacts.v1.Dashboard
 */
export type Dashboard = Message<"chalk.artifacts.v1.Dashboard"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: repeated chalk.artifacts.v1.DashboardWidget widgets = 4;
   */
  widgets: DashboardWidget[];

  /**
   * Free-form summary shown under the dashboard's title. Unset means "no description"; the server
   * normalizes a blank write to unset, so blank and unset are never two states of the same thing.
   *
   * @generated from field: optional string description = 13;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * Set together when another resource owns this dashboard as its backing layout (e.g.
   * owner_type="notebook" for a notebook app's live layout, "notebook_version" for an immutable
   * layout snapshot pinned by a notebook version). The dashboard service attaches no meaning to
   * the values beyond: owned dashboards are excluded from ListDashboards, and their lifecycle
   * (creation, deletion, snapshotting) is driven by the owning service, never from the dashboards
   * surface. Both are rejected on external Create/Update; the owning service writes them through
   * the store.
   *
   * @generated from field: optional string owner_type = 8;
   */
  ownerType?: string;

  /**
   * @generated from field: optional string owner_id = 9;
   */
  ownerId?: string;

  /**
   * Frozen at create by the owning service (layout snapshots). UpdateDashboard rejects writes to
   * read-only dashboards.
   *
   * @generated from field: bool read_only = 10;
   */
  readOnly: boolean;

  /**
   * View aggregates from entity_views (context "dashboard"), stamped by the server on reads.
   * Total opens across all users.
   *
   * @generated from field: int64 total_view_count = 11;
   */
  totalViewCount: bigint;

  /**
   * The requesting user's most recent open; unset if they have never opened it.
   *
   * @generated from field: google.protobuf.Timestamp viewer_last_viewed_at = 12;
   */
  viewerLastViewedAt?: Timestamp;

  /**
   * Written through Create/UpdateDashboardSharing, so `chalk apply` cannot widen access.
   *
   * @generated from field: chalk.artifacts.v1.ContentVisibility visibility = 14;
   */
  visibility: ContentVisibility;

  /**
   * The requesting caller's resolved role, so a listing can gate actions without a second call.
   *
   * @generated from field: chalk.artifacts.v1.ContentRole viewer_role = 15;
   */
  viewerRole: ContentRole;
};

/**
 * Describes the message chalk.artifacts.v1.Dashboard.
 * Use `create(DashboardSchema)` to create a new message.
 */
export const DashboardSchema: GenMessage<Dashboard> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_dashboard, 22);

/**
 * Coarse rendering mode for a notebook cell widget: the cell's output, its source, or both.
 *
 * @generated from enum chalk.artifacts.v1.NotebookCellDisplayMode
 */
export enum NotebookCellDisplayMode {
  /**
   * treated as OUTPUT
   *
   * @generated from enum value: NOTEBOOK_CELL_DISPLAY_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_CELL_DISPLAY_MODE_OUTPUT = 1;
   */
  OUTPUT = 1,

  /**
   * @generated from enum value: NOTEBOOK_CELL_DISPLAY_MODE_SOURCE = 2;
   */
  SOURCE = 2,

  /**
   * @generated from enum value: NOTEBOOK_CELL_DISPLAY_MODE_SOURCE_AND_OUTPUT = 3;
   */
  SOURCE_AND_OUTPUT = 3,
}

/**
 * Describes the enum chalk.artifacts.v1.NotebookCellDisplayMode.
 */
export const NotebookCellDisplayModeSchema: GenEnum<NotebookCellDisplayMode> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_dashboard, 0);

